export enum FormTemplateMode {
  Add = 'add',
  Edit = 'edit',
  EditVersion = 'editVersion',
  View = 'view',
  ViewLinkedTasks = 'viewLinkedTasks',
  Duplicate = 'duplicate',
}
